import { render, staticRenderFns } from "./AIChatWidgetRadio.vue?vue&type=template&id=3b98d6c8&scoped=true"
import script from "./AIChatWidgetRadio.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetRadio.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetRadio.vue?vue&type=style&index=0&id=3b98d6c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98d6c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b98d6c8')) {
      api.createRecord('3b98d6c8', component.options)
    } else {
      api.reload('3b98d6c8', component.options)
    }
    module.hot.accept("./AIChatWidgetRadio.vue?vue&type=template&id=3b98d6c8&scoped=true", function () {
      api.rerender('3b98d6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetRadio.vue"
export default component.exports